/** Paleta y tipo de ilustración por nicho (grilla comercial / programación). */
export const NICHE_THEMES = {
  news: {
    main: '#1565c0',
    accent: '#42a5f5',
    light: '#e3f2fd',
    gradient: 'linear-gradient(135deg, #0d47a1 0%, #1976d2 55%, #42a5f5 100%)',
    illustration: 'news',
    tagline: 'Actualidad, rigor y cobertura en vivo',
  },
  business: {
    main: '#2e7d32',
    accent: '#66bb6a',
    light: '#e8f5e9',
    gradient: 'linear-gradient(135deg, #1b5e20 0%, #388e3c 55%, #81c784 100%)',
    illustration: 'business',
    tagline: 'Empresas, economía y conversión B2B',
  },
  marketing: {
    main: '#c2185b',
    accent: '#f06292',
    light: '#fce4ec',
    gradient: 'linear-gradient(135deg, #880e4f 0%, #c2185b 50%, #f48fb1 100%)',
    illustration: 'marketing',
    tagline: 'Marcas, creatividad y storytelling',
  },
  interview: {
    main: '#0277bd',
    accent: '#4fc3f7',
    light: '#e1f5fe',
    gradient: 'linear-gradient(135deg, #01579b 0%, #0288d1 55%, #4fc3f7 100%)',
    illustration: 'marketing',
    tagline: 'Entrevistas, voceros y conversación en profundidad',
  },
  education: {
    main: '#6a1b9a',
    accent: '#ba68c8',
    light: '#f3e5f5',
    gradient: 'linear-gradient(135deg, #4a148c 0%, #7b1fa2 55%, #ce93d8 100%)',
    illustration: 'education',
    tagline: 'Formación, voz y desarrollo profesional',
  },
  wellness: {
    main: '#00838f',
    accent: '#4dd0e1',
    light: '#e0f7fa',
    gradient: 'linear-gradient(135deg, #006064 0%, #00838f 50%, #80deea 100%)',
    illustration: 'wellness',
    tagline: 'Bienestar, hábitos y calidad de vida',
  },
  maternity: {
    main: '#c2185b',
    accent: '#f48fb1',
    light: '#fce4ec',
    gradient: 'linear-gradient(135deg, #880e4f 0%, #c2185b 48%, #f8bbd0 100%)',
    illustration: 'stories',
    tagline: 'Maternidad, crianza y familia sin filtros',
  },
  faith: {
    main: '#5d4037',
    accent: '#a1887f',
    light: '#efebe9',
    gradient: 'linear-gradient(135deg, #3e2723 0%, #6d4c41 55%, #bcaaa4 100%)',
    illustration: 'faith',
    tagline: 'Valores, fe y conversación en comunidad',
  },
  stories: {
    main: '#ef6c00',
    accent: '#ffb74d',
    light: '#fff3e0',
    gradient: 'linear-gradient(135deg, #e65100 0%, #f57c00 55%, #ffcc80 100%)',
    illustration: 'stories',
    tagline: 'Relatos, voces y vidas reales',
  },
  justice: {
    main: '#37474f',
    accent: '#78909c',
    light: '#eceff1',
    gradient: 'linear-gradient(135deg, #263238 0%, #455a64 55%, #90a4ae 100%)',
    illustration: 'justice',
    tagline: 'Narrativa legal y ciudadanía',
  },
  realestate: {
    main: '#5c6bc0',
    accent: '#9fa8da',
    light: '#e8eaf6',
    gradient: 'linear-gradient(135deg, #283593 0%, #5c6bc0 55%, #b39ddb 100%)',
    illustration: 'realestate',
    tagline: 'PH, mercado inmobiliario y comunidad',
  },
  entertainment: {
    main: '#d81b60',
    accent: '#ff6090',
    light: '#fce4ec',
    gradient: 'linear-gradient(135deg, #ad1457 0%, #ec407a 55%, #f8bbd0 100%)',
    illustration: 'entertainment',
    tagline: 'Cine, espectáculos y entretenimiento',
  },
  segments: {
    main: '#f9a825',
    accent: '#ffd54f',
    light: '#fff8e1',
    gradient: 'linear-gradient(135deg, #f57f17 0%, #fbc02d 55%, #fff59d 100%)',
    illustration: 'segments',
    tagline: 'Micros, rotación y activaciones',
  },
  tourism: {
    main: '#0277bd',
    accent: '#4fc3f7',
    light: '#e1f5fe',
    gradient: 'linear-gradient(135deg, #01579b 0%, #0288d1 55%, #81d4fa 100%)',
    illustration: 'tourism',
    tagline: 'Viajes, destinos y experiencias',
  },
  food: {
    main: '#e65100',
    accent: '#ffb74d',
    light: '#fff3e0',
    gradient: 'linear-gradient(135deg, #bf360c 0%, #f57c00 55%, #ffcc80 100%)',
    illustration: 'wellness',
    tagline: 'Sabores, cocina y experiencias culinarias en antena',
  },
  fashion: {
    main: '#7b1fa2',
    accent: '#e040fb',
    light: '#f3e5f5',
    gradient: 'linear-gradient(135deg, #4a148c 0%, #7b1fa2 48%, #ce93d8 100%)',
    illustration: 'entertainment',
    tagline: 'Moda, tendencias y estilo en antena',
  },
  default: {
    main: '#3949ab',
    accent: '#7986cb',
    light: '#e8eaf6',
    gradient: 'linear-gradient(135deg, #1a237e 0%, #3949ab 55%, #9fa8da 100%)',
    illustration: 'default',
    tagline: 'Contenido especializado para audiencias de alto interés',
  },
};

const DEFAULT_VARIANTS = [
  {
    main: '#3949ab',
    accent: '#7986cb',
    light: '#e8eaf6',
    gradient: 'linear-gradient(135deg, #1a237e 0%, #3949ab 55%, #9fa8da 100%)',
  },
  {
    main: '#00796b',
    accent: '#4db6ac',
    light: '#e0f2f1',
    gradient: 'linear-gradient(135deg, #004d40 0%, #00796b 55%, #80cbc4 100%)',
  },
  {
    main: '#6d4c41',
    accent: '#a1887f',
    light: '#efebe9',
    gradient: 'linear-gradient(135deg, #4e342e 0%, #6d4c41 55%, #bcaaa4 100%)',
  },
  {
    main: '#455a64',
    accent: '#90a4ae',
    light: '#eceff1',
    gradient: 'linear-gradient(135deg, #263238 0%, #455a64 55%, #b0bec5 100%)',
  },
];

function hashCode(input) {
  let h = 0;
  const s = String(input || '');
  for (let i = 0; i < s.length; i += 1) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

function toTitleCase(s) {
  return String(s || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/(^|\s)\S/g, (m) => m.toUpperCase());
}

function buildAdhocDefaultTheme(nicheName) {
  const label = toTitleCase(nicheName || 'este vertical');
  const variant = DEFAULT_VARIANTS[hashCode(label) % DEFAULT_VARIANTS.length];
  return {
    ...NICHE_THEMES.default,
    ...variant,
    tagline: `Producciones y audiencias para ${label}.`,
  };
}

function normalizeNicheKey(s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function nicheSectionId(nicheName) {
  return String(nicheName || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function getNicheVisualTheme(nicheName) {
  const k = normalizeNicheKey(nicheName);
  if (/informativo|reportaje|deporte|actualidad|periodismo/.test(k)) return NICHE_THEMES.news;
  if (/negocio|emprend|economia|empresa|comercio/.test(k)) return NICHE_THEMES.business;
  if (/entrevista/.test(k)) return NICHE_THEMES.interview;
  if (/marketing|mercadeo|publicidad/.test(k)) return NICHE_THEMES.marketing;
  if (/educacion|formacion|oratoria|academy/.test(k)) return NICHE_THEMES.education;
  if (/fog[oó]n al micr[oó]fono|gastronom[ií]a|sabrosito|culinari/.test(k)) return NICHE_THEMES.food;
  if (/pasarela al aire|^moda$|pescando la moda|moda sostenible|fashion|estilo y tendencia/.test(k)) {
    return NICHE_THEMES.fashion;
  }
  if (/panza a brazos|maternidad|crianza|nido|materna|madres sin filtro|somos padres|frecuencia materna/.test(k)) {
    return NICHE_THEMES.maternity;
  }
  if (/zona life|bienestar|salud|mascota|life/.test(k)) return NICHE_THEMES.wellness;
  if (/divino|profano|fe|espiritual/.test(k)) return NICHE_THEMES.faith;
  if (/historia|humana|relato|podcast/.test(k)) return NICHE_THEMES.stories;
  if (/justicia|legal|delito|crimin|ciudadano/.test(k)) return NICHE_THEMES.justice;
  if (/inmobiliar|condominio|comunidad residencial|alma house/.test(k)) return NICHE_THEMES.realestate;
  if (/arte|espectaculo|entretenimiento|cine|musica/.test(k)) return NICHE_THEMES.entertainment;
  if (/segmento|micro|rotacion|comercial/.test(k)) return NICHE_THEMES.segments;
  if (/turismo|viaje|destino|pasaporte\s+social/.test(k)) return NICHE_THEMES.tourism;
  return buildAdhocDefaultTheme(nicheName);
}
